import React from 'react';
import {
  Box,
  Text,
  VStack,
  HStack,
  Heading,
  Pressable,
  Center,
  ChevronRightIcon,
} from 'native-base';
import {IClient} from '../../../../../../interfaces/dtos';

interface CustomProps {
  onPress: () => void;
  rowType: 'odd' | 'even';
}

type ItemProps = CustomProps & IClient;

const ClientListItem = (props: ItemProps) => {
  const {name, rif, onPress, rowType} = props;

  const handleOnPress = () => {
    onPress();
  };

  const getStripedColor = () => {
    if (rowType === 'odd') {
      return '#FFFFFF';
    }
    return '#F3F9FF';
  };

  return (
    <Pressable onPress={() => handleOnPress()}>
      <HStack
        width="100%"
        backgroundColor={getStripedColor()}
        paddingY={3}
        paddingX={5}>
        <VStack flex={1}>
          <Box height="5" justifyContent="center">
            <Heading size="sm" fontWeight="medium" color="black">
              {name}
            </Heading>
          </Box>
          <Box height="4" justifyContent="center">
            <Text color="#99A2B4" fontSize={'sm'} ellipsizeMode="tail">
              {rif}
            </Text>
          </Box>
        </VStack>
        <Box>
          <Center flex={1} paddingLeft={2}>
            <ChevronRightIcon size="5" color="blue.500" />
          </Center>
        </Box>
      </HStack>
    </Pressable>
  );
};

export default ClientListItem;
